import React, { useState } from 'react';

const TwoPanelLayout = ({ leftPanel, rightPanel }) => {
  const [activeTab, setActiveTab] = useState('controls');

  return (
    <div className="flex flex-col lg:flex-row bg-white dark:bg-gray-900 text-gray-900 dark:text-white h-full transition-colors duration-200">
      {/* Mobile/Tablet: Tab Navigation */}
      <div className="lg:hidden flex border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800">
        <button
          onClick={() => setActiveTab('controls')}
          className={`flex-1 px-4 py-3 text-sm font-medium transition-colors ${
            activeTab === 'controls'
              ? 'bg-gradient-primary text-white'
              : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
          }`}
        >
          Controls
        </button>
        <button
          onClick={() => setActiveTab('code')}
          className={`flex-1 px-4 py-3 text-sm font-medium transition-colors ${
            activeTab === 'code'
              ? 'bg-gradient-primary text-white'
              : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
          }`}
        >
          Code
        </button>
      </div>

      {/* Mobile: Single Panel */}
      <div className="lg:hidden flex-1 min-h-0 overflow-hidden">
        {activeTab === 'controls' && (
          <div className="bg-gray-50 dark:bg-gray-800 h-full overflow-y-auto">{leftPanel}</div>
        )}
        {activeTab === 'code' && (
          <div className="bg-gray-50 dark:bg-gray-800 h-full overflow-y-auto">{rightPanel}</div>
        )}
      </div>

      {/* Tablet: 2-Panel Layout (Controls | Code) */}
      <div className="hidden md:flex lg:hidden h-full">
        <div className="flex-1 bg-gray-50 dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 overflow-y-auto">
          {leftPanel}
        </div>
        <div className="w-96 bg-gray-50 dark:bg-gray-800 overflow-y-auto">{rightPanel}</div>
      </div>

      {/* Desktop: 2-Panel Layout - Both panels sticky and independently scrollable */}
      <div className="hidden lg:flex h-full w-full min-h-0">
        {/* Left Panel - Controls */}
        <div className="w-80 bg-gray-50 dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 flex-shrink-0 h-full overflow-y-auto sticky top-0">
          {leftPanel}
        </div>
        
        {/* Right Panel - Generated Code */}
        <div className="flex-1 bg-gray-50 dark:bg-gray-800 flex-shrink-0 h-full overflow-y-auto sticky top-0">
          {rightPanel}
        </div>
      </div>
    </div>
  );
};

export default TwoPanelLayout;
